export class InterruptedException extends Error {
    constructor(message?: string) {
        super(message || "Interrupted");
        this.name = "InterruptedException";
        Object.setPrototypeOf(this, InterruptedException.prototype);
    }
}
